import { useEffect } from 'react';
import { PRODUCT_NAME } from '@tallyframe/core';

/**
 * Sets `document.title`, always trailing with the product name so every tab
 * is identifiable at a glance in a browser with a dozen of them open.
 *
 * Every route calls this — even with no `title` — because unmounting the
 * previous route never resets `document.title` on its own; skipping the call
 * on a titleless screen would leave the last route's title showing.
 */
export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${PRODUCT_NAME}` : PRODUCT_NAME;
  }, [title]);
}
